import "./bootstrap"

import * as Sentry from "@sentry/vue"
import { createApp, h } from "vue"
import { createInertiaApp } from "@inertiajs/vue3"
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers"
import type { DefineComponent } from "vue"
import { createPinia } from "pinia"
import Vue3Toastify from "vue3-toastify"
import { reloadWhenConsentWithdrawn } from "@/lib/cookiebot"
import { trackMetaPageViews } from "@/lib/meta"

import { loadStripe } from "@stripe/stripe-js"

reloadWhenConsentWithdrawn()
trackMetaPageViews()

await loadStripe(import.meta.env.VITE_STRIPE_PK)

declare module "vite/client" {
  interface ImportMetaEnv {
    readonly VITE_APP_NAME: string
    [key: string]: string | boolean | undefined
  }

  interface ImportMeta {
    readonly env: ImportMetaEnv
    readonly glob: <T>(pattern: string) => Record<string, () => Promise<T>>
  }
}

const appName = import.meta.env.VITE_APP_NAME || "AnyWear"

createInertiaApp({
  title: (title) => `${title || "Personalised Clothing and Workwear Experts"}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob<DefineComponent>("./Pages/**/*.vue")
    ),
  setup({ el, App, props, plugin }) {
    const pinia = createPinia()

    const app = createApp({ render: () => h(App, props) })

    Sentry.init({
      app,
      dsn: "https://4245443aef6146cc6accd69f7e39a9f6@o4510317416415232.ingest.de.sentry.io/4510322880282704",
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
    })

    app
      .use(plugin)
      .use(pinia)
      .use(Vue3Toastify, {
        autoClose: 3000,
      })
      .mount(el)
  },
})
